import { render, staticRenderFns } from "./AllocationSharedPollSteps.vue?vue&type=template&id=4271e0d8"
import script from "./AllocationSharedPollSteps.vue?vue&type=script&lang=js"
export * from "./AllocationSharedPollSteps.vue?vue&type=script&lang=js"
import style0 from "./AllocationSharedPollSteps.vue?vue&type=style&index=0&id=4271e0d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports